/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import moment from "moment";
import DrugTransactionsReports from "./drugTransactions";

const DrugReports = ({ drugId, drugName, pharmacyBranchId }) => {
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  return (
    <>
      <h2>{drugName} Reports:</h2>
      <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>

        <input
          id="date-of-birth-input"
          test-id="date-of-birth-input"

          name="fromDate"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          type="date"
          max={moment().format("yyyy-MM-DD")}
          className="form-control"
          style={{ width: 250 }}
        />
        <input
          id="date-of-birth-input"
          test-id="date-of-birth-input"

          name="toDate"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          type="date"
          max={moment().format("yyyy-MM-DD")}
          className="form-control"
          style={{ width: 250 }}
        />
      </div>
      <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
        <DrugTransactionsReports drugId={drugId} fromDate={fromDate} toDate={toDate} pharmacyBranchId={pharmacyBranchId} />
      </div>
    </>
  );
};

export default DrugReports;
